module.exports = "<div>\r\n    <h3>Tailcode GK</h3>\r\n    <div class=\"resource\">\r\n        <h4>合同会社テイルコード</h4>\r\n        <p>テイルコードはアプリケーション・システム開発を通してみなさまに価値を提供します。</p>\r\n    </div>\r\n\r\n    <div class=\"resource\">\r\n        <h4>このサイトについて</h4>\r\n        <p>このサイトはAngular2 + webpackで作られました。</p>\r\n    </div>\r\n\r\n    <div class=\"resource\">\r\n      <h4>GACTアプリについて</h4>\r\n      <p>サポートメールアドレス：app.gact@tailcode.io</p>\r\n      <p>質問、ご要望等、お気軽にご連絡ください</p>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = 67
// module chunks = 0